/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetComponentControllerResponseDto
 */
export interface AssetComponentControllerResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AssetComponentControllerResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AssetComponentControllerResponseDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AssetComponentControllerResponseDto
     */
    ocppId?: string | null;
}

/**
 * Check if a given object implements the AssetComponentControllerResponseDto interface.
 */
export function instanceOfAssetComponentControllerResponseDto(value: object): value is AssetComponentControllerResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function AssetComponentControllerResponseDtoFromJSON(json: any): AssetComponentControllerResponseDto {
    return AssetComponentControllerResponseDtoFromJSONTyped(json, false);
}

export function AssetComponentControllerResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetComponentControllerResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'ocppId': json['ocppId'] == null ? undefined : json['ocppId'],
    };
}

export function AssetComponentControllerResponseDtoToJSON(json: any): AssetComponentControllerResponseDto {
    return AssetComponentControllerResponseDtoToJSONTyped(json, false);
}

export function AssetComponentControllerResponseDtoToJSONTyped(value?: AssetComponentControllerResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'ocppId': value['ocppId'],
    };
}

